import { forwardRef } from 'react';

import Tooltip from '@/components/mui/Tooltip';
import type { OcrWordsSelection } from '@/pages/document/DocumentViewer/DocumentFileView/PageView/PageOcrLayer/OcrWords/useOcrWordsSelection';
import { OcrWordsSelectionBoxRoot } from '@/pages/document/DocumentViewer/DocumentFileView/PageView/PageOcrLayer/OcrWords/OcrWordsSelectionBox/StyledComponents';

type Props = {
  selection: OcrWordsSelection;
  onPress: () => void;
};

const OcrWordsSelectionBox = forwardRef<HTMLDivElement, Props>(({ selection: { box, text }, onPress }, ref) => (
  <div style={box}>
    <OcrWordsSelectionBoxRoot
      ref={ref}
      role="toolbar"
      draggable="false"
      style={box}
      onPointerDown={onPress}
      data-document-drag-handle
    >
      <Tooltip t={text} placement="top" disableInteractive>
        <div style={{ width: box.width, height: box.height }} />
      </Tooltip>
    </OcrWordsSelectionBoxRoot>
  </div>
));

export default OcrWordsSelectionBox;
